// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button__Button__2s11z","Success":"Button__Success__230dH","Danger":"Button__Danger__3jlJD"};